import React, { Component } from 'react'
import Icon from '@softwaredev_cegeka/stix-core/dist/components/Icon'
import StixBreadcrumb from '@softwaredev_cegeka/stix-core/dist/components/Breadcrumb'
import { Link } from 'react-router-dom'
import { reverse } from 'src/routes/config'
import styles from './breadcrumb.module.scss'

class Breadcrumb extends Component {
    render() {
        const {
            match: { params },
            breadcrumbs,
        } = this.props
        let items = []
        if (breadcrumbs instanceof Function) {
            items = breadcrumbs(params)
        } else if (Array.isArray(breadcrumbs)) {
            items = breadcrumbs
        }
        return (
            <StixBreadcrumb className={styles.breadcrumb}>
                <StixBreadcrumb.HomeItem linkAs={Link} linkProps={{ to: '/' }}>
                    <Icon icon="home" />
                </StixBreadcrumb.HomeItem>
                {items.map((item, index) =>
                    item.linkName ? (
                        <StixBreadcrumb.Item
                            active={index === items.length - 1}
                            key={index}
                            linkAs={Link}
                            linkProps={{ to: reverse(item.linkName, params) }}
                        >
                            {item.label}
                        </StixBreadcrumb.Item>
                    ) : (
                        <StixBreadcrumb.Item
                            active={index === items.length - 1}
                            key={index}
                        >
                            {item.label}
                        </StixBreadcrumb.Item>
                    )
                )}
            </StixBreadcrumb>
        )
    }
}

export default Breadcrumb
